import { useMutation } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";

export default (queryOptions = {}) => {
  return useMutation({
    mutationKey: ["guidesAndTemplates"],
    mutationFn: (path) => {
      return apiClient
        .get(`gateway/guides-templates/download/${path}`)
        .then((response) => response?.data?.signedUrl);
    },
    ...queryOptions,
  });
};
